<div class="container-md">
    <div class="mt-3 mb-3 ms-2">
        <div>
            <label class="fw-bold title">{{ 'IDS_CHANGE_PASSWORD' | translate }}</label>
        </div>
        <form (ngSubmit)="onSubmit()" #resetPasswordForm="ngForm" *ngIf="!passwordChanged">
            <div class="form-group mb-4 mt-2">
            <label for="newPassword">{{'IDS_NEW_PASSWORD' | translate}}*</label>
            <input 
                type="password" 
                id="newPassword" 
                required
                [(ngModel)]="resetPassword.newPassword"
                class="form-control"
                name="newPassword">
            </div>
            <div class="form-group mb-4">
            <label for="confirmPassword">{{'IDS_CONFIRM_NEW_PASSWORD' | translate}}*</label>
            <input 
                type="password" 
                id="confirmPassword" 
                required
                [(ngModel)]="confirmPassword"
                class="form-control"
                name="confirmPassword">
            </div>
            <div class="red mb-2" *ngIf="passwordNotEqual">
                <label>{{'IDS_PASSWORD_NOT_EQUAL' | translate}}</label>
            </div>
            <div>
                <button type="submit" [disabled]="!resetPasswordForm.form.valid" class="mb-2 fw-bold text-uppercase btn-gold">{{ 'IDS_CHANGE_PASSWORD' | translate }}</button>
            </div>
        </form>
        <div class="green mb-2" *ngIf="passwordChanged">
            <label>{{'IDS_PASSWORD_CHANGED' | translate}}</label>
        </div>
    </div>
</div>
